import { ActionContext } from "vuex";
import decoinUseCase from "../../../../domain/usecase/impl/decoin/decoinUseCase";
import JSConfetti from "js-confetti";
import { DecoinLimit } from "../../../../domain/entities/decoins";
import { Order } from "../../../../domain/entities/order";

class DecoinsState {
  dailyDecoinLimit = false;
  acceptDailyDecoinLimitMessage = false;
  isVisibleDecoinsModalLimit = false;
  pdfExtractDecoins = "";
  excelExtractDecoins = "";
}

const state = new DecoinsState();

const mutations = {
  SET_DAILY_DECOIN_LIMIT(state: DecoinsState, dailyDecoinLimit: boolean): void {
    state.dailyDecoinLimit = dailyDecoinLimit;
  },
  SET_VISIBILITY_DECOINS_LIMIT_MODAL(
    state: DecoinsState,
    isVisible: boolean
  ): void {
    state.isVisibleDecoinsModalLimit = isVisible;
  },
  SET_ACCEPT_DAILY_DECOIN_LIMIT_MESSAGE(
    state: DecoinsState,
    acceptDailyDecoinLimitMessage: boolean
  ): void {
    state.acceptDailyDecoinLimitMessage = acceptDailyDecoinLimitMessage;
  },
  SET_PDF_EXTRACT_DECOINS(
    state: DecoinsState,
    pdfExtractDecoins: string
  ): void {
    state.pdfExtractDecoins = pdfExtractDecoins;
  },
  SET_EXCEL_EXTRACT_DECOINS(
    state: DecoinsState,
    excelExtractDecoins: string
  ): void {
    state.excelExtractDecoins = excelExtractDecoins;
  }
};

const actions = {
  async dailyDecoinLimit({
    commit
  }: ActionContext<DecoinsState, DecoinsState>): Promise<void> {
    const response: DecoinLimit = await decoinUseCase.dailyDecoinLimit();
    commit("SET_DAILY_DECOIN_LIMIT", response.isDecoinLimitExceed);
    commit(
      "SET_ACCEPT_DAILY_DECOIN_LIMIT_MESSAGE",
      response.acceptDailyDecoinLimitMessage
    );
  },
  async setDecoinsLimitModal(
    { commit }: ActionContext<DecoinsState, DecoinsState>,
    isVisible: boolean
  ): Promise<void> {
    console.log("chamou");
    if (state.acceptDailyDecoinLimitMessage) return;
    commit("SET_VISIBILITY_DECOINS_LIMIT_MODAL", isVisible);
    if (state.isVisibleDecoinsModalLimit) {
      const jsConfetti = new JSConfetti();
      await jsConfetti.addConfetti();
    }
  },
  async decoinDailyLimitMessageAccepted({
    commit
  }: ActionContext<DecoinsState, DecoinsState>): Promise<void> {
    return await decoinUseCase.decoinDailyLimitMessageAccepted();
  },

  async getPdfExtractDecoins(
    { commit }: ActionContext<DecoinsState, DecoinsState>,
    order: Order
  ): Promise<void> {
    try {
      const response: string = await decoinUseCase.getPdfExtractDecoins(order);
      commit("SET_PDF_EXTRACT_DECOINS", response);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async getExcelExtractDecoins(
    { commit }: ActionContext<DecoinsState, DecoinsState>,
    order: Order
  ): Promise<void> {
    try {
      const response: string = await decoinUseCase.getExcelExtractDecoins(
        order
      );
      commit("SET_EXCEL_EXTRACT_DECOINS", response);
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
};

const getters = {
  dailyDecoinLimit: (state: DecoinsState): boolean => state.dailyDecoinLimit,
  acceptDailyDecoinLimitMessage: (state: DecoinsState): boolean =>
    state.acceptDailyDecoinLimitMessage,
  isVisibleDecoinsModalLimit: (state: DecoinsState): boolean =>
    state.isVisibleDecoinsModalLimit,
  pdfExtractDecoins: (state: DecoinsState): string => state.pdfExtractDecoins,
  excelExtractDecoins: (state: DecoinsState): string =>
    state.excelExtractDecoins
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
